'use client';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
import { slugify } from 'shared/utils';

function capitalizeFirstLetter(str: string) {
  return str?.charAt(0).toUpperCase() + str?.slice(1);
}

export default function ProviderKnowMore({ provider }) {
  const { resources } = provider;
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <h3>{t('know_more')}</h3>
      <ul className={styles.link_list}>
        {resources
          ?.filter((el) => typeof el !== 'string')
          ?.map((resource, index) => {
            if (typeof resource !== 'string') {
              const type = resource.category
                ? slugify('is_' + resource.category.trim())
                : 'is_website';

              return (
                <li key={index}>
                  <a target="_blank" href={resource.link.startsWith("http") ? resource.link : `http://${resource.link}`} rel="noreferrer">
                    <div
                      className={`${styles.icon} ${
                        styles[type] || styles['is_website']
                      }`}
                    />
                    <div className={styles.info}>
                      <h4>{capitalizeFirstLetter(resource?.description)}</h4>
                      <small>
                        {capitalizeFirstLetter(
                          resource.type?.replaceAll('_', ' ')
                        )}
                      </small>
                    </div>
                  </a>
                </li>
              );
            }
          })}
      </ul>
    </div>
  );
}
